<script lang="ts" setup>
defineProps<{ large?: boolean }>()
const showSearch = ref(false)

const searchQuery = ref('')

watch(showSearch, (val) => {
  if (!val)
    searchQuery.value = ''
})
const pb = useNuxtApp().$pb
const { data: results, status, pending } = await useAsyncData('general-search', () => pb.collection('businessesOverview').getList<Business>(1, 10, {
  filter: pb.filter(`name ?~ {:query} || brief ?~ {:query}`, { query: searchQuery.value }),
}), { server: false, watch: [searchQuery], lazy: true, transform: data => structuredClone(data) })
</script>

<template>
  <div>
    <button type="button" class="hover:text-pink blu" aria-label="Search" @click=" showSearch = true">
      <Icon name="mdi:magnify" class="h-auto" :class="[large ? 'w-8' : 'w-6']" />
    </button>
    <UModal
      v-model="showSearch" :ui="{
        wrapper: 'z-[99] overflow-clip w-full',
        overlay: {
          background: 'bg-slate-900/80 backdrop-filter backdrop-blur-sm overflow-clip',
        },
        rounded: 'rounded-none',
        container: 'flex min-h-full text-center justify-start items-start sm:items-start md:items-start w-screen sm:p-0 !p-0 overflow-clip',
        margin: 'my-0 md:my-0 sm:my-0',
        width: 'w-full sm:max-w-full',
        transition: {
          enter: 'ease-out duration-300',
          enterFrom: 'opacity-0 -translate-y-4 sm:translate-y-0 sm:scale-100',
          enterTo: 'opacity-100 translate-y-0 sm:scale-100',
          leave: 'ease-in duration-200',
          leaveFrom: 'opacity-100 translate-y-0 sm:scale-100',
          leaveTo: 'opacity-0 -translate-y-4 sm:translate-y-0 sm:scale-100',
        },

      }"
    >
      <UInput
        id="searchIP" v-model="searchQuery" class="w-full lg:text-lg " placeholder="Search..." :ui="{
          rounded: 'rounded-none',
          size: {
            xl: 'md:text-lg lg:text-xl xl:text-2xl',
          },
          padding: {
            xl: 'py-3 md:py-4 lg:py-5 px-6',
          },
          color: {
            white: {
              outline: 'shadow-sm bg-white text-gray-900 ring-0 ring-inset ring-gray-300 dark:ring-gray-700 focus:ring-2 focus:ring-primary-500',
            },
          },
        }" size="xl" aria-autocomplete="none" autocomplete="one-time-code"
      >
        <template #leading>
          <Icon name="gravity-ui:magnifier" class="w-6 h-6 text-primary-500" />
        </template>
        <template #trailing>
          <transition name="fade">
            <Icon v-if="pending" name="eos-icons:loading" class="text-primary-500" />
          </transition>
        </template>
      </UInput>
      <transition name="fade" mode="out-in">
        <div v-if="searchQuery" class="max-h-screen pt-3 overflow-y-auto overflow-x-clip">
          <div class="flex flex-col max-w-3xl p-3 mx-auto md:p-6">
            <p class="px-2 mb-2 text-sm md:py-2 md:px-3 lg:px-4 text-slate-400">
              {{ results?.items?.length }} Result{{
                results?.items?.length === 1
                  ? '' : 's' }}
            </p>
            <template v-if="results?.items?.length">
              <transition-group name="list" tag="section" mode="out-in">
                <NuxtLink
                  v-for=" result in results?.items"
                  :key="result.id" class="inline-flex items-center w-full px-2 py-1 text-left md:py-2 lg:py-2 md:px-3 lg:px-4 hover:bg-slate-200" :to="`/${result.slug}`"
                >
                  {{ result.name }}
                </NuxtLink>
              </transition-group>
            </template>
          </div>
        </div>
      </transition>
    </UModal>
  </div>
</template>
